export const getLocaleStringText = (locale?: string | null) => locale?.trim() ?? '';
